import { useCallback, useMemo, useEffect } from 'react';
import { assoc, filter, keys } from 'ramda';

import {
  useMachineForm,
  useMachineValidate,
  useVersions,
} from 'app/dataProviders/VendingDataProvider';
import type { VersionsState } from 'app/dataProviders/VendingDataProvider';

type Result = {
  versions: VersionsState
  loadingVersions: boolean
  versionSelection: Array<string>
  changeCurrentVersion: (values: Array<string>) => void
}

export function useActualVersions(modelSelection: Array<string>): Result {
  const [{ versionId }, { update }] = useMachineForm();
  const [, , resetErrors] = useMachineValidate();

  const [versionsAvailable, loadingVersions, requestVersions] = useVersions();

  const versions = useMemo<VersionsState>(() => (
    filter(({ modelId: mId }) => modelSelection.includes(mId), versionsAvailable) as VersionsState
  ), [versionsAvailable, modelSelection]);

  const versionSelection = useMemo(() => (
    versionId
      ? [String(versionId)]
      : []
  ), [versionId]);

  const changeCurrentVersion = useCallback((values: Array<string>) => {
    const [versionId_] = values;
    resetErrors();
    update(assoc('versionId', parseInt(versionId_, 10) || 0));
  }, [update, resetErrors]);


  useEffect(() => {
    requestVersions();
  }, [requestVersions]);

  useEffect(() => {
    const versionIds = keys(versions).map(String);
    if (versionIds.length === 1) {
      changeCurrentVersion(versionIds);
    }
  }, [modelSelection]); // eslint-disable-line react-hooks/exhaustive-deps

  return {
    versions,
    loadingVersions,
    versionSelection,
    changeCurrentVersion,
  };
}
